import { render, staticRenderFns } from "./class-icon.vue?vue&type=template&id=5e3086a9&scoped=true"
import script from "./class-icon.vue?vue&type=script&lang=js"
export * from "./class-icon.vue?vue&type=script&lang=js"
import style0 from "./class-icon.vue?vue&type=style&index=0&id=5e3086a9&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3086a9",
  null
  
)

export default component.exports